import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#389A84',
      light: '#4ad1b4',
      dark: '#3aa18a',
    },
    secondary: {
      main: '#61dafb',
    },
    background: {
      default: '#f5f5f5',
    },
    jigsaw: {
      header: '#929292',
      green: '#BBD600',
      white: '#ffffff',
      blue: '#1A3F50',
      red: '#FF2D2D',
      darkRed: '#C62828',
      darkGrey: '#333333',
      success: '#4CAF50',
      fail: '#FF2D2D',
      statuses: {
        tenderInitialization: '#D64000',
        finalizedSummary: '#BBD600',
      },
      grey: '#888888',
      lightGrey: '#fafafa',
      lighterGreen: '#F8FDEB',
      lighterRed: '#FFF6F6',
      hoverBlue: '#f0f4ff',
    }
  },
  typography: {
    fontFamily: [
      'Poppins',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme; 